<template>
  <section class="upload-container">
    <input
      type="file"
      :placeholder="placeholder"
      @change="handleInput"
      id="file"
      ref="fileInput"
      multiple
      style="display:none"
    />
    <label
      for="file"
      v-on:dragover.prevent="handleDragOver"
      v-on:drop.prevent="handleDrop"
      v-on:dragleave.prevent="handleDragLeave"
      class="p-5 d-flex justify-content-between align-items-center flex-column text-center bg-light rounded"
      style="border: 3px dashed #ccc"
    >
      <legend>{{legend}}</legend>
      <i class="icon icon-file-outiline"></i>
    </label>

    <div>
      <ul class="m-0 p-0 mt-4">
        <li
          v-for="(item, i) in files_data"
          :key="i"
          class="d-flex w-100 justify-content-between align-items-center p-1 mb-2"
        >
          <span>
            <strong class="ml-3">{{ item.name }}</strong> 
            ({{item.size}}KB)
          </span>
          <button @click.prevent="removeFile(i)" class="btn"><i class="icon icon-delete-outlined"></i></button>
        </li>
      </ul>
    </div>
    <div class="upload-footer">
      <!-- <div v-if="status.dropped">
				<p class="upload-footer-file-name">{{ file.name }}</p>
				<small class="upload-footer-file-size">Size: {{ file.size }} kb</small>
			</div> -->
      <!-- <button @click="handleFileupload" class="upload-footer-button">
			</button> -->
    </div>
  </section>
</template>

<script>
export default {
  // Accept the heading from parent component
  props: ["files", "legend", "placeholder"],
  data() {
    return {
      loading: false,
      // Create a property that holds the file information
      file: {
        name: "MyScreenshot.jpg",
        size: 281923,
        value: "",
      },
      files_data: [],
      status: {
        over: false,
        dropped: false,
      },
    };
  },
  methods: {
    handleDragOver() {
      this.status.over = true;
    },

    handleInput(event) {
      let list_file = [];
      event.target.files.forEach((el) => {
        list_file.push(el);
        this.files_data.push({
          name: el.name,
          size: (el.size / 1000).toFixed(2),
        });
      });
      this.addFileList(event, list_file);
    },

    handleDrop(event) {
      this.status.dropped = true;
      this.status.over = false;
      let file_list = [];
      event.dataTransfer.items.forEach((el) => {
        let file = el.getAsFile();
        file_list.push(file);
        this.files_data.push({
          name: file.name,
          size: (file.size / 1000).toFixed(2),
        });
      });
      this.addFileList(event, file_list);

    },

    addFileList(event, files_selected) {
      // this.files.map.push(files)
      files_selected.map(el  => this.files.push(el))
      // files.forEach((file) => {
      //   const reader = new FileReader();
      //   reader.readAsDataURL(file);

      //   reader.onloadend = (event) => {
      //     const file = event.target.result;
      //     this.file.value = file;
      //     this.files.push(file);
      //   };
      // });
    },

    handleDragLeave() {
      this.status.over = false;
    },

    removeFile(i){
       this.files.splice(i, 1);
       this.files_data.splice(i, 1);
    }
  },
};
</script>

<style lang="scss" scoped>
ul {
  text-decoration: none;
}
li {
  border: 1px solid #cccccc;
  border-radius: 5px;
  .icon {
    height: 22px;
    width: 22px;
  }
}
</style>
